"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = randomWeight;
function randomWeight() {
  return Math.random() * 0.4 - 0.2;
}
//# sourceMappingURL=random-weight.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/brain.js/dist/utilities/random-weight.js
// module id = 5Pqs
// module chunks = 0